<template>
    <bottom-dialog
        v-model="showDialog"
        max-width="850px"
        :dialog="!$vuetify.breakpoint.mobile"
    >
        <v-card class="zoezi-bottom-sheet course-booking-sheet-card" elevation="0">
            <course-booking
                :courseId="course.id"
                dialog
                :show-lastname-for-instructors="showLastnameForInstructors"
                @close="showDialog = false"
            />
        </v-card>
    </bottom-dialog>
</template>

<script>
import CourseBooking from '../views/CourseBooking.vue'
import BottomDialog from './BottomDialog.vue'

export default {
    name: 'zoezi-coursebooking-dialog',
    props: {
        value: {},
        booking: {},
        showLastnameForInstructors: {
            type: Boolean,
            default: false
        }
    },

    components: {
        CourseBooking,
        BottomDialog
    },

    watch: {
        value: {
            immediate: true,
            handler(value) {
                this.showDialog = value;
            }
        },
        showDialog(value) {
            this.$emit('input', value);
        },
        booking: {
            immediate: true,
            handler() {
                if (this.booking && this.course.id != this.booking.course_id) {
                    this.$api.get('/api/public/course/get', {id: this.booking.course_id}).then(courses => {
                        this.course = courses[0];
                    });
                }
            }
        }
    },
    data: () => ({
        showDialog : false,
        course: {}
    })
}
</script>
